export const beforeItems = [
  "Your gastrointestinal nutrition references are scattered across different documents.",
  "You spend time searching for specific concepts.",
  "You find yourself switching between textbooks, articles, and notes.",
  "Organizing gastrointestinal assessment information feels unnecessarily complicated.",
  "Your case study materials and worksheets are difficult to locate.",
  "You want a clearer structure for continuing professional education.",
];

export const afterItems = [
  "Six educational volumes organized around distinct professional topics.",
  "Structured references covering gastrointestinal physiology and digestion.",
  "Educational frameworks for organizing nutritional assessment information.",
  "Reference materials covering digestive health and dietary considerations.",
  "Hypothetical case studies for structured educational review.",
  "Worksheets for organizing nutrition care planning discussions.",
  "Documentation templates and reference organization tools.",
];
